import CollectionContainer from '../containers/Collection';
import { waitForElements } from '../helpers/utils';
import SoftLoad from '../modules/SoftLoad';
const startCollectionInstore = () => {
    console.log('UNTUCKit : Template : CollectionInstoreTemplate');
    SoftLoad.inStoreAsync();
    // accessibility fix for boost filter checkboxes
    waitForElements('.bc-sf-filter-option-multiple-list input[data-value]').then((els) => {
        els.forEach((el) => el.setAttribute('aria-label', el.dataset.value));
    });
    new CollectionContainer();
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCollectionInstore, { once: true });
}
else {
    startCollectionInstore();
}
